import { useState, useCallback } from "react";

export type GeoLocation = {
  latitude: number;
  longitude: number;
};

export type GeoLocationError = {
  code: number;
  message: string;
};

export type UseGeoLocationResult = {
  location: GeoLocation | null;
  error: GeoLocationError | null;
  loading: boolean;
  requestLocation: () => Promise<GeoLocation>;
};

export function useGeoLocation(): UseGeoLocationResult {
  const [location, setLocation] = useState<GeoLocation | null>(null);
  const [error, setError] = useState<GeoLocationError | null>(null);
  const [loading, setLoading] = useState(false);

  const requestLocation = useCallback((): Promise<GeoLocation> => {
    setLoading(true);
    setError(null);

    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const loc = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          setLocation(loc);
          setLoading(false);
          resolve(loc);
        },
        (err) => {
          const geoError = { code: err.code, message: err.message };
          setError(geoError);
          setLoading(false);
          reject(geoError);
        },
      );
    });
  }, []);

  return {
    location,
    error,
    loading,
    requestLocation,
  };
}
